// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"0464d0c4","607":"161389d8","737":"e6ef2db6","787":"c58be9c0"}[chunkId] + ".chunk.js";
};